module.exports = __webpack_public_path__ + "static/media/search.f9f08784.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/search.svg
// module id = 119
// module chunks = 0